import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDateFromTimestamp } from "../../utility/functions";

const initialState = {
  shouldShowSidebar: true,
  status: "idle",
};

export const setLightboxVideoAsync = createAsyncThunk(
  "ui/setLightboxVideoAsync",
  async ({ video }) => {    
    return { video };
  }
);

export const clearLightboxVideoAsync = createAsyncThunk(
  "ui/clearLightboxVideoAsync",
  async () => {
    return true;
  }
);

export const setLastWatchedVideoAsync = createAsyncThunk(
  "ui/setLastWatchedVideoAsync",
  async ({ video }) => {
    return { video };
  }
);

export const setNextVideoInSequenceAsync = createAsyncThunk(
  "ui/setNextVideoInSequenceAsync",
  async ({ video }) => {
    return { video };
  }
);

export const setLightboxVideoProgressAsync = createAsyncThunk(
  "ui/setLightboxVideoProgressAsync",
  async ({ progress }) => {
    return { progress };
  }
);

export const setShouldShowSidebar = createAsyncThunk(
  "ui/setShouldShowSidebar",
  async (shouldShowSidebar) => shouldShowSidebar
);

export const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setLightboxVideoAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(setLightboxVideoAsync.fulfilled, (state, { payload }) => {
        if (!payload) {
          state.lightboxVideo = undefined;
        } else {
          state.lightboxVideo = payload.video;
        }

        state.status = `idle`;
      })
      .addCase(clearLightboxVideoAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(clearLightboxVideoAsync.fulfilled, (state) => {
        state.lightboxVideo = undefined;
        state.nextVideoLink = undefined;
        state.prevVideoLink = undefined;
        state.status = `idle`;
      })
      .addCase(setLastWatchedVideoAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(setLastWatchedVideoAsync.fulfilled, (state, { payload }) => {
        state.lastWatchedVideo = payload.video;
        state.status = `idle`;
      })
      .addCase(setNextVideoInSequenceAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(setNextVideoInSequenceAsync.fulfilled, (state, { payload }) => {
        state.status = `idle`;
      })
      .addCase(setShouldShowSidebar.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(
        setShouldShowSidebar.fulfilled,
        (state, { payload }) => {
          state.shouldShowSidebar = payload;
          state.status = `loading`;
        }
      )
      .addCase(setLightboxVideoProgressAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(setLightboxVideoProgressAsync.fulfilled, (state, { payload }) => {
        const progress = payload.progress;

        if (state.lightboxVideo) {
          state.lightboxVideo.progress = {
            percent: progress.percent,
            seconds: progress.seconds,
            timestamp: getDateFromTimestamp(progress.timestamp)
          }
        }       

        state.status = `idle`;
      })
  },
});

export default uiSlice.reducer;
